module.exports = __webpack_public_path__ + "img/client-camp.75527c53.png";